import type { ComponentType, SVGProps } from 'react';
import SpotAccountIcon from '@/shared/assets/account-spot-icon.svg?react';
import MarginAccountIcon from '@/shared/assets/account-margin-icon.svg?react';
import InvestAccountIcon from '@/shared/assets/account-invest-icon.svg?react';
import EarnAccountIcon from '@/shared/assets/account-earn-icon.svg?react';
import type { TradingAccountType } from '../model';

export const ACCOUNT_TYPE_ICONS: Record<
  TradingAccountType,
  ComponentType<SVGProps<SVGSVGElement>>
> = {
  spot: SpotAccountIcon,
  leverage: MarginAccountIcon,
  invest: InvestAccountIcon,
  earn: EarnAccountIcon,
};

export const ACCOUNT_TYPE_LABEL_KEYS: Record<TradingAccountType, string> = {
  spot: 'personalAccount.overview.cards.spot',
  leverage: 'personalAccount.overview.cards.leverage',
  invest: 'personalAccount.overview.cards.invest',
  earn: 'personalAccount.overview.cards.earn',
};
